import { Organizations } from '@components/reports/charities';
import { Donations } from '@components/reports/donations';
import { TextHeader } from '@components/ui/text-header';
import { Paper, Stack, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { useIncentiveOverview } from '@queries/incentives';
import { formatUsd, round, stripZeroPennies } from '@utils/money';
import { FunctionComponent } from 'react';

export type DonationsProps = {
  incentiveGids?: string[];
};

export const Dashboard: FunctionComponent<DonationsProps> = (props) => {
  const { incentiveGids } = props;
  const { data } = useIncentiveOverview({
    campaignGids: incentiveGids,
  });

  return (
    <Stack spacing={3}>
      <Stack spacing={3}>
        <Grid container spacing={3}>
          <Grid xs={6} sm={6} md={6} lg={3} xl={3}>
            <Paper sx={{ p: 3 }}>
              <Stack spacing={2}>
                <TextHeader
                  title="Credits"
                  subtitle="Redeemed"
                  titleProps={{ fontWeight: 600 }}
                />
                <Typography variant="h2" textAlign="right">
                  {data?.data?.donationCount ?? 0}
                </Typography>
              </Stack>
            </Paper>
          </Grid>
          <Grid xs={6} sm={6} md={6} lg={3} xl={3}>
            <Paper sx={{ p: 3 }}>
              <Stack spacing={2}>
                <TextHeader
                  title="Credits"
                  subtitle="Generated"
                  titleProps={{ fontWeight: 600 }}
                />
                <Typography variant="h2" textAlign="right">
                  {data?.data?.donationCreditCount ?? 0}
                </Typography>
              </Stack>
            </Paper>
          </Grid>
          <Grid xs={6} sm={6} md={6} lg={3} xl={3}>
            <Paper sx={{ p: 3 }}>
              <Stack spacing={2}>
                <TextHeader
                  title="Redemption"
                  subtitle="Rate"
                  titleProps={{ fontWeight: 600 }}
                />
                <Typography variant="h2" textAlign="right">
                  {`${round((data?.data?.redemptionRate ?? 0) * 100)}%`}
                </Typography>
              </Stack>
            </Paper>
          </Grid>
          <Grid xs={6} sm={6} md={6} lg={3} xl={3}>
            <Paper sx={{ p: 3 }}>
              <Stack spacing={2}>
                <TextHeader
                  title="Amount"
                  subtitle="Donated"
                  titleProps={{ fontWeight: 600 }}
                />
                <Typography variant="h2" textAlign="right">
                  {stripZeroPennies(formatUsd(data?.data.amountDonated ?? 0))}
                </Typography>
              </Stack>
            </Paper>
          </Grid>
        </Grid>
      </Stack>
      <Stack>
        <Grid container spacing={3}>
          <Grid xs={12} sm={12} md={12} lg={6} xl={6}>
            <Paper sx={{ p: 3 }}>
              <Typography variant="h5" sx={{ mb: 2 }}>
                Charities
              </Typography>
              <Organizations incentiveGids={incentiveGids} />
            </Paper>
          </Grid>
          <Grid xs={12} sm={12} md={12} lg={6} xl={6}>
            <Paper sx={{ p: 3 }}>
              <Typography variant="h5" sx={{ mb: 2 }}>
                Donations
              </Typography>
              <Donations incentiveGids={incentiveGids} />
            </Paper>
          </Grid>
        </Grid>
      </Stack>
    </Stack>
  );
};
